import { SearchSortService } from "@app/services/search-sort.service"
import { StoreService } from "../services/store.service"
import { LangService } from "@app/services/lang.service"
import {
	Component,
	Input,
	OnInit,
	Output,
	ViewChild,
	EventEmitter,
	ElementRef,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ApiService } from "@app/services/api.service"
import { ModalService } from "@app/services/modal.service"
import {
	ConfigDefinitions,
	FollowupserieSave,
	FusCrudReturnObj,
	patientColors,
} from "@app/definitions/types"
import themePlugin from "@fullcalendar/angular/themes/classic"

import {
	FullCalendarComponent,
	FullCalendarModule,
} from "@fullcalendar/angular"
import { CalendarOptions } from "@fullcalendar/angular"
import * as moment from "moment"
import { EventsService } from "@app/services/events.service"
import { PermsService } from "@app/services/perms.service"
import listPlugin from "@fullcalendar/angular/list"
import timegridPlugin from "@fullcalendar/angular/timegrid"
import interactionPlugin from "@fullcalendar/angular/interaction"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { AutocompleteWithTagsComponent } from "@app/gen-inputs/autocomplete-with-tags/autocomplete-with-tags.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { TimeAllocationFormComponent } from "@app/time-allocation-form/time-allocation-form.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"
import { RouterLink } from "@angular/router"
import { arrToCls } from "@app/helpers"
import { fcCommonClasses, fcCommonOptions } from "@app/fc"

@Component({
	selector: "app-time-allocation",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		AutocompleteWithTagsComponent,
		GenAutocompleteComponent,
		FullCalendarModule,
		ModalWrapComponent,
		TimeAllocationFormComponent,
		GenTableDisplayComponent,
		RouterLink,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./time-allocation.component.html",
})
export class TimeAllocationComponent implements OnInit {
	modalProps: any = null
	hoverObj: any = null
	cliniqData: any
	currentView: "timeGridWeek" | "listWeek" = "timeGridWeek"

	@ViewChild("calendar") calendar: FullCalendarComponent
	// @ViewChild("datePicker") datePicker:DatePickerComponent;
	events: any[] = []

	@ViewChild("subUsersFuzzy") subUsersFuzzy: GenAutocompleteComponent
	currentUserId: number = 0
	subUserIds: number[] = []

	calendarOptions: CalendarOptions = {
		plugins: [listPlugin, interactionPlugin, timegridPlugin, themePlugin],
		...fcCommonOptions,
		locale: this.lang.langCode,
		direction: this.lang.isRtl ? "rtl" : "ltr",

		eventContent: this.eventContent.bind(this),
		eventClick: this.handleEventClick.bind(this), // bind is important!
		dateClick: this.handleDateClick.bind(this),
		eventDrop: this.handleEventDrop.bind(this),
		eventResize: this.handleEventResize.bind(this),
		eventDidMount: this.evMount.bind(this),
		dayHeaderContent: this.dayHeaderContent.bind(this),
		listDayHeaderContent: (arg: any) => (arg.level ? "" : arg.text),

		listDayHeaderClass: "justify-content-center",
		listItemEventBeforeClass: "bullet",
		...fcCommonClasses,

		editable: true,
		navLinks: false,
		views: {
			week: {
				titleFormat: { year: "numeric", month: "2-digit", day: "2-digit" },
			},
		},
	}
	constructor(
		protected apiService: ApiService,
		public modalService: ModalService,
		public lang: LangService,
		public store: StoreService,
		protected searchSortService: SearchSortService,
		protected eventsService: EventsService,
		public permsService: PermsService
	) {}
	eventContent(arg: any) {
		let ev = arg.event
		return { html: ev.title }
	}

	changeView(view: "timeGridWeek" | "listWeek") {
		this.currentView = view
		this.calendar.getApi().changeView(view)
	}
	evMount(ev: any) {
		return
		if (this.currentView == "timeGridWeek") {
			return
		}
		const style = ev.el.style
		style.backgroundColor = ev.backgroundColor
		style.borderColor = ev.borderColor
		style.color = "white"
		ev.el.classList.remove("fc-event")
		// ev.el.style.borderWidth = "0px";

		// ev.el.parentNode.style.marginLeft = "0px";
		// ev.el.parentNode.style.right = "0%";
		// ev.el.parentNode.style.left = "40%";
		// ev.el.parentNode.style.zIndex = "0";
	}

	async ngOnInit() {
		this.cliniqData = this.store.cc()

		this.resetSubUserIds()

		this.eventsService.updateTitle(this.lang.getVal("time_allocation"))
		this.calendarOptions.slotMinTime = this.cliniqData.calendar_start_time
		this.calendarOptions.slotMaxTime = this.cliniqData.calendar_end_time

		const tableName = this.permsService.owner_has_users
			? "time_allocations"
			: "solo_time_allocations"

		const res: any = await this.store.get_gen_items(tableName)
		this.events = res[tableName]
		this.loadEvents()
	}

	async loadEvents() {
		if (!this.calendar?.getApi()) {
			await this.store.timeout(500)
			this.loadEvents()
			return
		}
		const firstDay = moment.utc(this.calendar.getApi().view.currentStart)
		const alpha = "10"
		const sub_users = this.store.getSiteDataTable("sub_users")
		const locations = this.store.getSiteDataTable("locations")

		let events = this.events

		if (this.permsService.owner_has_users) {
			events = events.filter((ev) =>
				this.subUserIds.find((subUserId) => ev.user_id == subUserId)
			)
		}

		if (this.currentUserId) {
			events = events.filter((ev) => ev.user_id == this.currentUserId)
		}
		events = events.map((ev) => {
			const color =
				patientColors[ev.user_id % patientColors.length] || "lightblue"
			const day = moment.utc(firstDay).add(ev.day, "days")
			const start = new Date(
				day.format(ConfigDefinitions.momentDateFormat) + " " + ev.time + "Z"
			)
			const end = new Date(
				day.format(ConfigDefinitions.momentDateFormat) + " " + ev.time_to + "Z"
			)
			const sub_user = sub_users.find((it) => it.id == ev.user_id)
			const location = locations.find((it) => it.id == ev.location_id)
			const time = ev.time.split(":")
			if (time.length > 2) {
				time.pop()
			}
			const time_to = ev.time_to.split(":")
			if (time_to.length > 2) {
				time_to.pop()
			}
			let title = time.join(":") + "-" + time_to.join(":")
			if (this.permsService.owner_has_users) {
				title +=
					"<br>" +
					sub_user?.name +
					": " +
					(location?.name || this.lang.getVal("no_location"))
			}

			return {
				id: ev.id,
				start,
				end,
				title,
				// start: new Date(fusInstance.instance_start_unix * 1000),
				// end: new Date(fusInstance.instance_end_unix * 1000),
				color,
				//  eventColor:patientColors[ev.color],
				borderColor: "#00000000",
				//  backgroundColor:patientColors[ev.color],
				extendedProps: { dbObj: ev },
				// editable: !fusInstance.isInVac
			}
		})
		this.calendar
			.getApi()
			.getEventSources()
			.forEach((ev) => ev.remove())
		this.calendar.getApi().addEventSource(events)

		this.getApiKeys()
	}

	dayHeaderContent(arg: any) {
		if (this.currentView == "listWeek") {
			return { html: `<div ><span>${arg.text}</span></div>` }
		}

		const arr = arg.text.split(" ")
		arr.pop()

		// let arr = arg.text.replace("שבת", "ש").replace("יום ", "").split(" ");
		// arr[0] = arr[0].replace("׳", "");
		// let html = `<div>${arr.map(it => `<span>${it}</span>`).join("")}</div>`;
		let html = `<div class="week-view"><span>${arr.join(" ")}</span></div>`

		return { html }
	}

	handleEventResize(arg: any) {
		const dbObj = arg.event?.extendedProps?.dbObj || null
		const insertObj = { ...dbObj }
		insertObj.time_to = moment.utc(arg.event.end).format("HH:mm")
		this.preUpdate(insertObj)
	}

	handleEventClick(arg: any) {
		const dbObj = arg.event?.extendedProps?.dbObj || null
		const insertObj = { ...dbObj }
		this.preUpdate(insertObj)
	}
	handleformClose(retObj: any = null) {
		if (retObj?.id) {
			this.events = this.events.filter((it) => it.id != retObj.id)
			this.events.push(retObj)
			this.loadEvents()
		} else if (retObj?.deletedId) {
			this.events = this.events.filter((it) => it.id != retObj.deletedId)
			this.loadEvents()
		}
	}
	async preUpdate(insertObj: any) {
		this.modalProps = {
			name: "time-allocation-form",
			insertObj,
			isUpdateMode: true,
		}
	}

	async handleDateClick(arg: any) {
		if (!this.calendar.getApi()) {
			this.modalService.openToast("1") //this.lang.getVal("an_error_occured_please_reload"));
			return
		}
		const time = moment.utc(arg.date)
		const time_to = moment.utc(time).add(1, "hours")

		//get time and time to
		const insertObj = {
			time: time.format("HH:mm"),
			time_to: time_to.format("HH:mm"),
			day: time.weekday(),
			user_id: this.currentUserId,
		}
		this.modalProps = {
			name: "time-allocation-form",
			insertObj,
		}
	}

	handleEventDrop(arg: any) {
		const dbObj = arg.event?.extendedProps?.dbObj || null
		const insertObj = { ...dbObj }
		insertObj.day = moment.utc(arg.event.start).weekday()
		insertObj.time = moment.utc(arg.event.start).format("HH:mm")
		insertObj.time_to = moment.utc(arg.event.end).format("HH:mm")
		this.preUpdate(insertObj)
	}

	subUserMove(dir: number) {
		let siteDataSubUsers: any = this.store.getSiteDataTable("sub_users")
		siteDataSubUsers = siteDataSubUsers.filter((it) =>
			this.subUserIds.includes(it.id)
		)
		// if (this.subUserIds?.length) {
		// }
		const subUsers = [{ id: 0 }, ...siteDataSubUsers]
		const curIndex = subUsers.findIndex((it) => it.id == this.currentUserId)

		let nextIndex = (subUsers.length + curIndex + dir) % subUsers.length
		this.updSubUser(subUsers[nextIndex]?.id || 0)
	}

	async chooseTags(tagObjs: any[]) {
		this.resetSubUserIds()

		if (tagObjs?.length) {
			this.subUserIds = []
			const tagIds = tagObjs.map((it) => Number(it.id))
			//get user ids to tags
			const userIdsToTagArray = {}
			const o2t = this.store
				.getSiteDataTable("object_to_tags")
				.filter((row) => row.item_type == "user")
			o2t.forEach((o2tRow) => {
				if (!userIdsToTagArray[o2tRow.item_id]) {
					userIdsToTagArray[o2tRow.item_id] = []
				}
				userIdsToTagArray[o2tRow.item_id].push(Number(o2tRow.tag_id))
			})
			//only get total cross of arrays
			Object.keys(userIdsToTagArray).forEach((user_id) => {
				const userTagArray = userIdsToTagArray[user_id]
				if (tagIds.every((tag_id) => userTagArray.includes(tag_id))) {
					this.subUserIds.push(Number(user_id))
				}
			})
		}
		this.subUsersClick()
		await this.store.timeout(200)
		this.subUsersFuzzy.focus()
		this.subUsersFuzzy.clickInput()
	}
	updSubUser(id: number) {
		this.currentUserId = id
		this.loadEvents()
		this.subUsersFuzzy.searchStr =
			this.store.getSiteDataTable("sub_users").find((it) => it.id == id)
				?.name || ""
	}

	subUsersClick(obj: any = null) {
		this.updSubUser(obj?.id || 0)
	}

	resetSubUserIds() {
		this.subUserIds = this.store
			.getSiteDataTable("sub_users")
			.map((it) => it.id)
	}

	async getApiKeys() {
		// if(this.permsService.owner_has_users){return}

		if (!this.events.length && !this.permsService.owner_has_users) {
			return
		}

		const cc = this.store.cc()
		if (cc.meeting_request_with_calendar == "yes") {
			const meetingtypes = this.store.getSiteDataTable("meetingtypes")
			if (
				!meetingtypes.find((mt) => mt?.first_time_meeting_request == "yes") ||
				!meetingtypes.find((mt) => mt?.return_meeting_request == "yes")
			) {
				return
			}
		}
	}

	async handleSoloTimeAllocationsClose() {
		const res: any = await this.store.get_gen_items("solo_time_allocations")
		this.events = res.solo_time_allocations
		this.loadEvents()
	}
}
